import { useTheme, isTrellisTheme } from 'foundations-theming/utils';
import { fwcColor } from 'foundations-theming/utils/fwc';
import { rgba } from '../../utils/color';
export const useRingColor = use => {
  const theme = useTheme();
  switch (use) {
    case 'on-dark':
    case 'secondary-ghost':
      {
        const ringColor = theme.color[fwcColor('fwc-loadingspinner-ring-ghost')];
        return isTrellisTheme(theme) ? ringColor : rgba(ringColor, 0.21);
      }
    case 'danger':
      return theme.color[fwcColor('fwc-loadingspinner-ring-danger')];
    case 'primary':
    case 'secondary':
    case 'secondary-alt':
      return theme.color[fwcColor('fwc-loadingspinner-ring-primary')];
    case 'primary-white':
    case 'tertiary':
    case 'tertiary-light':
    case 'tertiary-extra-light':
    case 'tertiary-transparent':
      return theme.color[fwcColor('fwc-loadingspinner-ring-tertiary')];
    case 'primary-on-fill':
    case 'tertiary-on-fill':
      return theme.color[fwcColor('fwc-loadingspinner-ring-onfill')];
    case 'success':
      return theme.color[fwcColor('fwc-loadingspinner-ring-success')];
    case 'link':
      {
        const ringColor = theme.color[fwcColor('fwc-loadingspinner-ring-link')];
        return isTrellisTheme(theme) ? ringColor : rgba(ringColor, 0.21);
      }
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument:\n ${use}`);
      }
  }
};
export const useIndicatorColor = use => {
  const theme = useTheme();
  switch (use) {
    case 'danger':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-danger')];
    case 'primary':
    case 'secondary':
    case 'secondary-alt':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-primary')];
    case 'primary-white':
    case 'tertiary':
    case 'tertiary-light':
    case 'tertiary-extra-light':
    case 'tertiary-transparent':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-tertiary')];
    case 'primary-on-fill':
    case 'tertiary-on-fill':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-onfill')];
    case 'success':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-success')];
    case 'on-dark':
    case 'secondary-ghost':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-ghost')];
    case 'link':
      return theme.color[fwcColor('fwc-loadingspinner-indicator-link')];
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument:\n ${use}`);
      }
  }
};